const SCROLL_DOWN = 'SCROLL_DOWN';
const SCROLL_UP = 'SCROLL_UP';


const handleScrollingUp = () => ({
    type: SCROLL_UP,
    payload: {
        scroll_direction: "up"
    },
});

const handleScrollingDown = () => ({
    type: SCROLL_DOWN,
    payload: {
        scroll_direction: "down"
    },
});

export {
    SCROLL_UP,
    SCROLL_DOWN,
    handleScrollingUp,
    handleScrollingDown,
}
